import { EAssetType } from 'constants/enums';
import { ROLLING_OFFER_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { InputSelectDropdownOption } from 'components/InputSelectDropdown/InputSelectDropdown';

import {
  GradientFieldConfig,
  TextFieldConfig,
  UploadFieldConfig
} from '../FormFields.types';

export { ROLLING_OFFER_DEFAULTS };

export const FREE_TILES_LAYOUT_OPTIONS: InputSelectDropdownOption[] = [
  { value: '1', label: '1 in a row' },
  { value: '2', label: '2 in a row' },
  { value: '3', label: '3 in a row' }
];

export const COLLECT_TEXT_FIELD: TextFieldConfig = {
  label: 'Free Offer Text',
  name: 'collectText',
  placeholder: 'FREE',
  defaultValue: ''
};

export const ONE_PLUS_MANY_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Offer Header',
    fieldName: 'headerImage',
    forceType: EAssetType.OFFER_HEADER,
    tooltip: 'Upload an image for the offer header.'
  },
  {
    title: 'Plus Image',
    fieldName: 'plusImage',
    forceType: EAssetType.GENERAL,
    tooltip:
      'Upload a 1:1 ratio image used as the visual plus separator between the paid tile and the free tiles.',
    isRequired: true
  },
  {
    title: 'Claimed Icon Image',
    fieldName: 'claimedIconImage',
    forceType: EAssetType.GENERAL,
    tooltip:
      'Upload the icon shown on a sub-offer tile once the player has claimed it.',
    isRequired: true
  }
];

export const MAIN_OFFER_BACKGROUND_COLOR: GradientFieldConfig = {
  header: 'Background Color',
  name: 'backgroundColor',
  fallback: ROLLING_OFFER_DEFAULTS.backgroundColor,
  dataTestId: 'offer-design-buy-one-get-many-main-background-color-input'
};

export const MAIN_OFFER_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Background Image',
    fieldName: 'offersBackgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Background image rendered on the paid (main) sub-offer tile.'
  }
];

export const SUB_OFFER_BG_FIELDS: GradientFieldConfig[] = [
  {
    header: 'Background Color',
    name: 'offersBackgroundColor',
    fallback: ROLLING_OFFER_DEFAULTS.subOfferBackgroundColor,
    dataTestId:
      'offer-design-buy-one-get-many-sub-offers-background-color-input'
  }
];

export const SUB_OFFER_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Background Image',
    fieldName: 'freeTilesBackgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Background image rendered on the free sub-offer tiles.'
  },
  {
    title: 'Lock Image',
    fieldName: 'offersLockImage',
    forceType: EAssetType.GENERAL,
    tooltip:
      'Upload the lock icon shown on locked sub-offers before they are unlocked.',
    isRequired: true
  }
];
